module.exports = "https://static.wmbcdn.com/uniweb/images/c010b75afa97fe7c3f969cfcf16352bd.svg";